import React from "react";

function Newaboutus() {
  return (
    <section className="about-us-area py-0 py-md-3 rel z-1">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-7 d-flex align-items-center ps-3 ps-lg-5">
            <div className="w-100">
              {/* Heading */}
              <div className="section-title">
                <h3
                  className="newAboutUs-title"
                  style={{
                    margin: "10px 0 10px",
                    fontWeight: "bold",
                    fontSize: "1.6rem",
                    fontFamily: "'EB Garamond', serif",
                    letterSpacing: "1px",
                    fontStyle: "italic",
                  }}
                >
                  Book Hotels. Unlock Offers. Plan Seamlessly - All with the JTDC App!
                </h3>
              </div>

              {/* Image: only visible on mobile */}
              <div className="d-block d-lg-none text-center">
                <img
                  src="assets/images/about/phone.png"
                  alt="JTDC App"
                  className="img-fluid"
                  style={{ maxWidth: "250px", margin: "10px 0" }}
                />
              </div>

              {/* Content */}
              <p style={{ fontSize: "1.1rem", margin: "0 0 10px 0" }}>
                Discover Jharkhand like never before - from scenic getaways and cultural
                trails to curated experiences, right at your fingertips. Book hotels,
                explore destinations, and plan your perfect journey with ease while we
                take care of the details.
                <br />
                <br />
                <span>
                  Download the official JTDC App now and start exploring Jharkhand with
                  smarter travel planning and seamless hotel booking.
                </span>
              </p>

              {/* Features */}
              <ul
                className="list-style-two no-tick"
                style={{
                  margin: "10px 0",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "8px 20px",
                  listStyle: "none",
                  padding: 0,
                }}
              >
                <li>
                  <i className="fas fa-hotel me-2 text-orange"></i>
                  <small>Hotel Booking</small>
                </li>

                <li>
                  <i className="fas fa-map-marked-alt me-2 text-orange"></i>
                  <small>Tour Planning</small>
                </li>

                <li>
                  <i className="fas fa-tags me-2 text-orange"></i>
                  <small>Exclusive Offers</small>
                </li>

                <li>
                  <i className="fas fa-headset me-2 text-orange"></i>
                  <small>24×7 Support</small>
                </li>
              </ul>

              {/* Download Button */}
              <div className="mt-3">
                <a
                  href="https://play.google.com/store/apps/details?id=in.gov.jtdc.hotelbooking"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    textDecoration: "none",
                    transition: "0.3s ease",
                  }}
                >
                  <img
                    src="assets/images/mobile-app/g-play.jpg"
                    alt="Download on Google Play"
                    style={{
                      width: "180px",
                      height: "auto",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Image on right: only visible on desktop */}
          <div className="col-12 col-lg-5 d-none d-lg-block">
            <div className="position-relative text-center">
              <img
                src="assets/images/about/phone.png"
                alt="JTDC App"
                className="img-fluid"
                style={{ maxWidth: "350px", margin: "0" }}
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Newaboutus;